import { MainContentWrapper } from './styles';

type Props = {
  element: JSX.Element;
};

export function MainContentLayout({ element }: Props) {
  return <MainContentWrapper>{element}</MainContentWrapper>;
}
